import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollUp from '../components/ScrollUp';
import blogPosts from '../data/blogPosts';
import './BlogsPage.css';

const BlogCard = ({ post }) => {
  const navigate = useNavigate();

  return (
    <div
      className="blog-card"
      onClick={() => navigate(`/blog/${post.slug}`)}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/blog/${post.slug}`)}
      aria-label={`Read: ${post.title}`}
    >
      {/* Top row: series tag + arrow */}
      <div className="blog-card__header">
        <span className="blog-card__series-tag">{post.seriesTag}</span>
        <div className="blog-card__arrow">
          <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
        </div>
      </div>

      {/* Title & subtitle */}
      <h3 className="blog-card__title">{post.title}</h3>
      <p className="blog-card__subtitle">{post.subtitle}</p>

      {/* Footer: meta + tags */}
      <div className="blog-card__footer">
        <div className="blog-card__meta">
          <span className="blog-card__meta-item">
            <i className="ri-time-line" aria-hidden="true"></i>
            {post.readTime}
          </span>
          <span className="blog-card__meta-item">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            {post.date}
          </span>
        </div>
        <div className="blog-card__tags">
          {post.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="blog-card__tag">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

const BlogsPage = ({ darkTheme, toggleTheme }) => {
  // Group by series for the banner
  const seriesNames = [...new Set(blogPosts.map((p) => p.series))];

  return (
    <>
      <Header darkTheme={darkTheme} toggleTheme={toggleTheme} isBlogPage />

      <main className="blogs-page">
        {/* ── Hero ── */}
        <section className="blogs__hero">
          <div className="blogs__hero-inner">
            <p className="blogs__hero-tag">
              <i className="ri-quill-pen-line" aria-hidden="true"></i>
              Writing
            </p>
            <h1 className="blogs__hero-title">
              <span>Research &amp; Writing</span>
            </h1>
            <p className="blogs__hero-subtitle">
              In-depth articles on AI, machine learning, and the projects I'm
              building — from the problems that sparked the work to the
              experiments that shaped the results.
            </p>
          </div>
          <div className="blogs__hero-accent" aria-hidden="true"></div>
        </section>

        {/* ── Series banner ── */}
        {seriesNames.map((series) => {
          const count = blogPosts.filter((p) => p.series === series).length;
          return (
            <div className="blogs__series-banner" key={series}>
              <div className="blogs__series-icon">
                <i className="ri-seedling-line" aria-hidden="true"></i>
              </div>
              <div className="blogs__series-text">
                <h3>{series}</h3>
                <p>
                  A {count}-part series on reinforcement learning for
                  sustainable agriculture in Pakistan
                </p>
              </div>
            </div>
          );
        })}

        {/* ── Posts grid ── */}
        <div className="blogs__container">
          <div className="blogs__grid">
            {blogPosts.map((post) => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        </div>
      </main>

      <Footer />
      <ScrollUp />
    </>
  );
};

export default BlogsPage;
